import { Button, Icon } from '@platform/components';
import { ReactNode, useState } from 'react';
import ContentPanel from './ContentPanel';
import { H2 } from './utils';
import FaqAvatarGroup from './images/faq-avatar-group.svg';

const FAQSection = ({
  items,
}: {
  items: {
    question: string;
    answer: ReactNode;
  }[];
}) => {
  const [visibleIndices, setVisibleIndices] = useState<Set<number>>(new Set());
  return (
    <ContentPanel background='dark-gray'>
      <div className='text-center'>
        <H2 whiteText>Frequently asked questions</H2>
        <div className='mt-4 sm:mt-5 text-lg sm:text-xl leading-7 sm:leading-8 text-gray-300'>
          We're here to support you every step of the way
        </div>
        <div className='mt-12 text-left'>
          {items.map((item, index) => (
            <div key={index} className='pt-6 mb-8 border-t-1 border-t-gray-600 '>
              <div
                className='flex text-lg font-medium text-white cursor-pointer'
                onClick={() => {
                  setVisibleIndices((prev) => {
                    const newSet = new Set(prev);
                    if (newSet.has(index)) {
                      newSet.delete(index);
                    } else {
                      newSet.add(index);
                    }
                    return newSet;
                  });
                }}
              >
                <div>{item.question}</div>
                <div className='ml-auto mt-0.5 text-gray-400'>
                  <Icon type={visibleIndices.has(index) ? 'minus-circle' : 'plus-circle'} />
                </div>
              </div>
              {visibleIndices.has(index) && (
                <div className='mt-2 text-gray-200 sm:pr-8'>{item.answer}</div>
              )}
            </div>
          ))}
        </div>
        <div className='flex flex-col gap-6 bg-gray-900 mt-12 sm:mt-16 py-8 px-5 rounded-2xl'>
          <img className='mx-auto' src={FaqAvatarGroup} />
          <div>
            <div className='text-xl font-semibold'>Still have questions?</div>
            <div className='mt-2 text-base leading-6'>
              Can't find the answer you're looking for? Our friendly team is here to help
            </div>
          </div>
          <div className='mx-auto w-fit'>
            <Button variant='secondary-gray' size='lg' href='mailto:support@movingworlds.org'>
              Get in touch
            </Button>
          </div>
        </div>
      </div>
    </ContentPanel>
  );
};

export default FAQSection;
